import PropTypes from 'prop-types';
import React from 'react';
import get from 'lodash/get';
import GalleryStore from './../../stores/GalleryStore.js';

const ReactPropTypes = PropTypes;

class Thumb extends React.Component {
  static propTypes = {
    id: ReactPropTypes.string,
  };

  static defaultProps = {
    id: '',
    thumbSize: 'o-n',
    link: true,
    uncensored: false,
  };

  state = {
    uncensored: this.props.uncensored,
  };

  showUncensored = (id) => {
    GalleryStore.setLocalUncensoredByFilename(id, false);
    GalleryStore.emitChange();
  }

  onChange = () => {
    const uncensored = GalleryStore.getLocalUncensoredByFilename(this.props.id);
    if (uncensored === null) {
      this.setState({ uncensored: this.props.uncensored });
      return;
    }

    this.setState({ uncensored });
  }

  componentDidMount() {
    GalleryStore.addChangeListener(this.onChange);
  }
  
  componentWillUnmount() {
    GalleryStore.removeChangeListener(this.onChange);
  }

  render() {
    if (this.props.id == '') {
      return (<span />);
    }

    let className = 'imagesThumb-image';
    let thumbSize = this.props.thumbSize;
    let imgClassName = '';
    if (this.props.openGallery && !this.state.uncensored) {
      className += ' op-gallery-open';
    }

    if (this.props.thumbSize == 'auto') {
      className += ' imagesThumb-image--auto';
      thumbSize = 'm';
    } else if (this.props.thumbSize == 't') {
      className += ' imagesThumb-image--s';
    } else if (this.props.thumbSize == 'l') {
      className += ' imagesThumb-image--l';
    } else if (this.props.thumbSize == 'm') {
      className += ' memberImage--m';
      imgClassName = 'memberImage-item';
    }

    if (this.state.uncensored) {
      className += ' imagesThumb-image--uncensored';
    }

    let baseURL = '/';
    if (this.props.baseURL) {
      baseURL = this.props.baseURL;
    }
    /* else if (op.cache_servers && op.cache_servers.length) {
      baseURL = op.cache_servers[0];
    }  */
    else {
      baseURL = `${window.location.protocol}//${window.location.host}/`;
    }

    if (baseURL.charAt(baseURL.length - 1) !== '/') {
      baseURL += '/';
    }

    let srcThumb = '';
    if (this.props.id == 'blank') {
      let imgName = 'blank';
      if (this.props.defaultPathModifier) {
        imgName += `-${this.props.defaultPathModifier.toLowerCase()}`;
      }
      srcThumb = `${baseURL}img/profile/${imgName}.png`;
    } else {
      srcThumb = `${baseURL}${this.props.gcloud ? '' : 'images/get/'}${thumbSize}/${this.props.id}`;
      if (this.props.defaultPathModifier) {
        srcThumb += `/${this.props.defaultPathModifier.toLowerCase()}`;
      }
    }
    const srcFull = `${baseURL}${this.props.gcloud ? '' : 'images/get/'}h/${this.props.id}`;

    if (this.props.link) {
      if (this.state.uncensored) {
        return (
          <div className={className} data-file={this.props.id}>
            <img src={srcThumb} className={imgClassName} />
            <div className="vcenter poa abst">
              <div className="vcenter-inner">
                <div className="tcl mam mtxs">
                  {get(translations, 'txt: Šis attēls, iespējams, ir seksuāla vai vardarbīga rakstura.', '')}
                </div>
                <div
                  role="button"
                  onClick={() => this.showUncensored(this.props.id)}
                  onKeyDown={() => this.showUncensored(this.props.id)}
                  tabIndex="0"
                  className="btn btn--b btn--small mtxs mrs mbxs mls tac"
                >
                  {_.get(translations, 'txt: Parādīt attēlu', '')}
                </div>
              </div>
            </div>
          </div>
        );
      }

      return (
        <a href={srcFull} target="_blank" className={className} data-file={this.props.id} data-load-local>
          <img src={srcThumb} className={imgClassName} />
        </a>
      );
    }

    return (
      <div className={className}>
        <img src={srcThumb} />
      </div>
    );
  }
  }

module.exports = Thumb;
